module.exports = {
    kingData: () => {
        return[
            {
            "Logo":require("./../../UI/general/Sidebar/logos-motos/tvs-king.svg"),
            "Motos":[
                {
                    "Nombre":"Motocarro King Basico",
                    "Logo":require('./../../UI/general/Sidebar/btns-motos/king/king.svg'),
                    "Foto":require('./../../UI/general/Sidebar/btns-motos/king/king-moto.png')
                },
                {
                    "Nombre":"Motocarro King Carpa Especial",
                    "Logo":require('./../../UI/general/Sidebar/btns-motos/king/king.svg'),
                    "Foto":require('./../../UI/general/Sidebar/btns-motos/king/King_02.png')
                },
                {
                    "Nombre":"Motocarro King Carpa Full",
                    "Logo":require('./../../UI/general/Sidebar/btns-motos/king/king.svg'),
                    "Foto":require('./../../UI/general/Sidebar/btns-motos/king/King_03.png')
                }
            ]
            }
        ]
    }
}